import React from 'react';
import { withRouter, Route, Redirect, Switch } from 'react-router-dom';
import './assets/styles/global.scss';
import LoginPage from './features/login/login';
import Main from './features/main/main';
import Dashboard from './features/dashboard/dashboard';
import Account from './features/account/account';
import OcrFileList from './features/ocr/file-list';
import AsapFileList from './features/ocr/asap-file-list';
import AsapDetails from './features/ocr/asap-details';
import OcrUploadFile from './features/ocr/upload-file';
import UploadRecording from './features/recording/upload-recording';
import RecordingFileList from './features/recording/recording-list';
import RecordingDetails from './features/recording-details/recording-details';
import StreamList from './features/stream/stream-list';
import StreamDetails from './features/stream-details/stream-details';
import TagList from './features/tag/tag-list';
import PrivateRoute from './features/private-route/private-route';
import ActivatePage from './features/activation/activate-page';
import SettingList from './features/rpa/setting-list';
import CreateSetting from './features/rpa/create-process-config';
import EditSetting from './features/rpa/edit-process-config';
import MainLogging from './features/main-logging/main-logging';
import MainLoggingDetails from './features/main-logging/main-logging-details';
import Pipeline from './features/process-discovery/pipeline';
import Discovery from './features/process-discovery/discovery';
import Companies from './features/settings/companies';
import CreateCompany from './features/settings/create-company';
import CompanyDetails from './features/settings/company-details';
import { checkAuthenticate } from './shared/services/user-services';
import SetUpPassword from './features/activation/set-up-password';
import { useSelector } from 'react-redux';
import Page404 from './features/page404/page-404';
import GetOTP from './features/rpa/get-otp';
import TaskHistory from './features/rpa/task-history';
import TaskTrigger from './features/rpa/task-trigger';
import Reports from './features/reports/reports';
import ReportDetails from './features/reports/report-details';
import ForgotPassword from './features/forgot-password/forgot-password';

const LAST_VISITED_PATH_KEY = 'lastVisitedPath';

function App() {
	
	let authenticated = checkAuthenticate();
	// console.log("Authenticated", authenticated);

	return (
		<Switch>
			<Route
				exact
				path='/login'
				render={() => {
					if (!authenticated) {
						return <LoginPage />;
					}
					else {
						const lastVisitedPath = sessionStorage.getItem(LAST_VISITED_PATH_KEY);
						const redirectPath =
							lastVisitedPath && lastVisitedPath !== '/login'
								? lastVisitedPath
								: '/';

						sessionStorage.removeItem(LAST_VISITED_PATH_KEY);
						return <Redirect to={redirectPath} />;
					}
				}}
			/>
			<PrivateRoute
				exact
				path='/'
				render={() => (
					<Main selectedKey={['1']}>
						<Dashboard />
					</Main>
				)}
			/>
			<Route
				exact
				path='/register/activate/:activationCode'
				render={() => <ActivatePage />}
			/>
			<Route
				exact
				path='/setup-password/:activationCode'
				render={() => <SetUpPassword />}
			/>
			<Route
				exact
				path='/forgot-password'
				render={() => <ForgotPassword />}
			/>
			<PrivateRoute
				exact
				path='/account'
				render={() => (
					<Main selectedKey={['1']}>
						<Account />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/ocr/file-list'
				render={() => (
					<Main selectedKey={['3']} openKey={['documents']}>
						<OcrFileList />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/asap/cases'
				render={() => (
					<Main selectedKey={['asap-cases']} openKey={['documents']}>
						<AsapFileList />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/asap/cases/:caseId'
				render={() => (
					<Main selectedKey={['asap-cases']} openKey={['documents']}>
						<AsapDetails />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/ocr/upload'
				render={() => (
					<Main selectedKey={['5']} openKey={['documents']}>
						<OcrUploadFile />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/events/:recordingId'
				render={() => (
					<Main selectedKey={['event-list']} openKey={['agents']}>
						<RecordingDetails />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/events'
				render={() => (
					<Main selectedKey={['event-list']} openKey={['agents']}>
						<RecordingFileList />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/streams'
				render={() => (
					<Main
						selectedKey={['assistant-stream']}
						openKey={['agents']}
					>
						<StreamList />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/streams/:streamId'
				render={() => (
					<Main
						selectedKey={['assistant-stream']}
						openKey={['agents']}
					>
						<StreamDetails />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/upload-recording'
				render={() => (
					<Main
						selectedKey={['upload-recording']}
						openKey={['agents']}
					>
						<UploadRecording />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/tags'
				render={() => (
					<Main selectedKey={['tag-list']} openKey={['agents']}>
						<TagList />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/rpa/process-config'
				render={() => (
					<Main selectedKey={['process-config']} openKey={['rpa', 'configurations']}>
						<SettingList />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/rpa/create-process-config'
				render={() => (
					<Main selectedKey={['setting-list']} openKey={['rpa']}>
						<CreateSetting />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/rpa/edit-process-config/:settingId'
				render={() => (
					<Main selectedKey={['setting-list']} openKey={['rpa']}>
						<EditSetting />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/rpa/main-logging'
				render={() => (
					<Main selectedKey={['main-logging']} openKey={['rpa']}>
						<MainLogging />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/rpa/main-logging/:loggingId'
				render={() => (
					<Main selectedKey={['main-logging']} openKey={['rpa']}>
						<MainLoggingDetails />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/rpa/task-history'
				render={() => (
					<Main selectedKey={['task-history']} openKey={['rpa', 'configurations']}>
						<TaskHistory />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/rpa/get-otp'
				render={() => (
					<Main selectedKey={['get-otp']} openKey={['rpa', 'configurations']}>
						<GetOTP />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/rpa/task-trigger'
				render={() => (
					<Main selectedKey={['task-trigger']} openKey={['rpa', 'configurations']}>
						<TaskTrigger />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/pd/pipeline'
				render={() => (
					<Main selectedKey={['pipeline']} openKey={['pd']}>
						<Pipeline />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/pd/discovery'
				render={() => (
					<Main selectedKey={['discovery']} openKey={['pd']}>
						<Discovery />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/settings/companies'
				render={() => (
					<Main selectedKey={['companies']} openKey={['settings']}>
						<Companies />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/settings/create-company'
				render={() => (
					<Main selectedKey={['companies']} openKey={['settings']}>
						<CreateCompany />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/settings/companies/:companyId'
				render={() => (
					<Main selectedKey={['companies']} openKey={['settings']}>
						<CompanyDetails />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/reports'
				render={() => (
					<Main selectedKey={['reports']}>
						<Reports />
					</Main>
				)}
			/>
			<PrivateRoute
				exact
				path='/companyreports/:reportId'
				render={() => (
					<Main selectedKey={['1']}>
						<ReportDetails />
					</Main>
				)}
			/>

		</Switch>
	);
}

export default withRouter(App);
